import React, { Component } from 'react';
import { AppProvider, Spinner } from '@shopify/polaris';
import { getFetch } from '../helpers/request';


interface LoginPageProps { }

interface LoginPageState {
  shopOrigin: string,
  error: string
}

class LoginPage extends Component <LoginPageProps, LoginPageState> {

  constructor(props: LoginPageProps) {
    super(props);
    this.state = {
      shopOrigin: '',
      error: ''
    };
  }

  componentDidMount() {
    this.startAuthFlow();
  }

  startAuthFlow(attempt: number = 1) {
    getFetch('/app/api/shopify/auth', {})
      .then((res: any) => {
        if (res instanceof Error) {
          throw res;
        }

        if (res.status === 403) {
          return res.json().then((errorData: any) => {
            if (errorData.error === 'permission_required') {
              if (errorData.permission_url) {
                // Token exchange only inherits already-granted scopes; new
                // scopes (e.g. read_locations) need the OAuth grant screen,
                // which must open top-level, not inside the embedded iframe.
                window.open(errorData.permission_url, '_top');
                return Promise.reject('redirect');
              }
              return this.runTokenExchange();
            }
            throw new Error('Authorization failed');
          });
        }

        if (res.ok) {
          return res.json();
        }

        return this.runTokenExchange();
      })
      .then((data: any) => {
          if (!data) return;

          if (data.error) {
            this.setState({ error: data.error });
            return;
          }

          if (data.uninstalled || data.billing_url) {
            if (data.billing_url) {
              window.open(data.billing_url, '_top');
              return;
            }
            return this.runTokenExchange();
          } else {
            window.location.assign('/collection-listing');
          }
        }).catch((err: any) => {
            if (err === 'redirect') return;
            if (attempt < 3) {
              setTimeout(() => this.startAuthFlow(attempt + 1), 2000);
            } else {
              this.setState({ error: err.message || String(err) });
            }
        });
  }

  runTokenExchange() {
    return getFetch('/app/api/shopify/install', {})
      .then((res: any) => {
        if (res instanceof Error) throw res;
        return res.json();
      })
      .then((data: any) => {
        if (data.error) {
          throw new Error('Token exchange failed: ' + data.error);
        }
        if (data.active) {
          window.location.assign('/collection-listing');
          return Promise.reject('redirect');
        }
        if (data.billing_url) {
          window.open(data.billing_url, '_top');
          return Promise.reject('redirect');
        }
        return data;
      });
  }

  render() {
    return (
        <AppProvider i18n={{}}>
          <div style={{padding: '40px', textAlign: 'center'}}>
            {this.state.error
              ? <p>{this.state.error}</p>
              : <Spinner size="large" />
            }
          </div>
        </AppProvider>
    );
  }
}

export default LoginPage;
